export interface BreadcrumbSegment {
  label: string;
  to?: string;
}

export interface CollapsedBreadcrumb {
  head: BreadcrumbSegment[];
  hidden: BreadcrumbSegment[];
  tail: BreadcrumbSegment[];
}

/**
 * Deep paths render as `first › … › parent › current`; everything between
 * the first segment and the last two collapses behind the … menu.
 */
export const MAX_VISIBLE_SEGMENTS = 4;

export function collapseBreadcrumbSegments(
  segments: BreadcrumbSegment[]
): CollapsedBreadcrumb {
  if (segments.length <= MAX_VISIBLE_SEGMENTS) {
    return { head: segments, hidden: [], tail: [] };
  }
  return {
    head: [segments[0]],
    hidden: segments.slice(1, -2),
    tail: segments.slice(-2),
  };
}
